var useCustomIcons = function () {
    var getCustomIcons = function (getBadgeIcons) {
        if (getBadgeIcons) {
            return getBadgeIcons;
        }
        return null;
    };
    return { getCustomIcons: getCustomIcons };
};

export { useCustomIcons };
